// src/components/PayNowButton.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PayNowButton = ({ upiId, amount = 0, leadId }) => {
  const [isPaying, setIsPaying] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const navigate = useNavigate();

  const handlePayment = async () => {
    setIsPaying(true);

    try {
      // Simulate payment processing (replace with actual payment gateway integration)
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Payment success
      setPaymentStatus("success");

      // Here you would typically:
      // 1. Call your backend API to update payment status
      // 2. Redirect or show success message
      navigate("/payment-success", {
        state: {
          leadId,
          amount,
          transactionId: "TXN" + Math.random().toString(36).substring(2, 10),
        },
      });
    } catch (error) {
      setPaymentStatus("failed");
      console.error("Payment failed:", error);
    } finally {
      setIsPaying(false);
    }
  };

  return (
    <div className="payment-container">
      {paymentStatus === "failed" && (
        <p className="text-red-500 mb-2">Payment failed. Please try again.</p>
      )}

      <button
        onClick={handlePayment}
        disabled={isPaying}
        className={`px-6 py-3 rounded-md font-medium ${
          isPaying
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-green-600 hover:bg-green-700 text-white"
        }`}
      >
        {isPaying ? "Processing..." : `Pay ₹${amount}`}
      </button>

      <div className="mt-4 text-sm text-gray-600">
        <p>UPI ID: {upiId}</p>
        <p className="text-xs mt-1">You'll be redirected to your UPI app</p>
      </div>
    </div>
  );
};

export default PayNowButton;
